import Center from "../Base/Center";
import ListTab, { ListTabItem } from "../List/ListTab";
import { cn } from "@/shared/utils/cn";
import { useTranslation } from "react-i18next";
import {
  useReadSplitPaymentOrdersState,
  useSetSplitPaymentOrdersState,
} from "@/shared/atoms/useSplitPaymentV2Atom";

const SplitPaymentTypeTab = () => {
  const { t } = useTranslation();
  const { splitType } = useReadSplitPaymentOrdersState();
  const setSplitPaymentStates = useSetSplitPaymentOrdersState();

  return (
    <Center className="w-full md:w-auto md:self-start">
      <ListTab className="mb-0 max-w-full rounded-xl md:mb-5">
        <ListTabItem
          onClick={() => setSplitPaymentStates({ splitType: "custom" })}
          active={splitType === "custom"}
          className={cn(
            "px-3 py-2 text-lg md:text-2xl rounded-xl",
            splitType === "custom" && "text-dark bold"
          )}
        >
          {t("posOrders.customSplit")}
        </ListTabItem>
        <ListTabItem
          onClick={() => setSplitPaymentStates({ splitType: "cart" })}
          active={splitType === "cart"}
          className={cn(
            "px-3 py-2 text-lg md:text-2xl rounded-xl",
            splitType === "cart" && "text-dark bold"
          )}
        >
          {t("posOrders.cartSplit")}
        </ListTabItem>
      </ListTab>
    </Center>
  );
};

export default SplitPaymentTypeTab;
